import { useAutoneTranslation } from '@autone/translations';
import { type FC, useMemo } from 'react';

import { Button, PopoverTrigger } from '../../../../atoms';
import { ArrowRightShortIcon, ClockIcon } from '../../../../icons';
import { cn } from '../../../../utils';
import { SIDEBAR_MENU_BUTTON_STYLE_OVERRIDES } from '../../constants/sidebarMenuButtonStyleOverrides';
import { DATA_FRESHNESS_BUTTON_ID } from '../const';
import { type DatasetsDataFreshnessStatus } from '../DataFreshnessWidget.types';
import { formatDatasetAge, getFreshnessStatusTextColor } from '../utils';

interface DataFreshnessNavButtonProps {
  status: DatasetsDataFreshnessStatus;
  ageDays: number | null;
}

export const DataFreshnessNavButton: FC<DataFreshnessNavButtonProps> = ({
  status,
  ageDays,
}) => {
  const { common, lang } = useAutoneTranslation();
  const textColor = useMemo(
    () => getFreshnessStatusTextColor(status),
    [status],
  );

  const formattedAge = formatDatasetAge(ageDays, lang, common);

  return (
    <PopoverTrigger asChild>
      <Button
        id={DATA_FRESHNESS_BUTTON_ID}
        aria-label={common('data-age.global-widget.label')}
        variant="ghost"
        className={SIDEBAR_MENU_BUTTON_STYLE_OVERRIDES}
      >
        <ClockIcon className={textColor} />
        <div className="flex items-center gap-3 w-full group-data-[state=collapsed]:hidden">
          <div className="font-normal">
            {common('data-age.global-widget.label')}
          </div>
          <div className={cn('font-medium ml-auto', textColor)}>
            {formattedAge}
          </div>
          <div>
            <ArrowRightShortIcon />
          </div>
        </div>
      </Button>
    </PopoverTrigger>
  );
};
